import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["backdrop", "content"];

  connect() {
    this.holdThePageStill();
    Promise.all([enter(this.backdropTarget), enter(this.contentTarget)]);
  }

  disconnect() {
    this.letThePageMoveAgain();
  }

  close() {
    Promise.all([leave(this.backdropTarget), leave(this.contentTarget)]).then(
      () => this.element.remove(),
    );
  }

  holdThePageStill() {
    const scrollbar = window.innerWidth - document.documentElement.clientWidth;

    this.pageOverflow = document.documentElement.style.overflow;
    this.pagePaddingRight = document.documentElement.style.paddingRight;

    document.documentElement.style.overflow = "hidden";
    if (scrollbar > 0)
      document.documentElement.style.paddingRight = `${scrollbar}px`;

    this.bodyOverscroll = document.body.style.overscrollBehavior;
    document.body.style.overscrollBehavior = "contain";
  }

  letThePageMoveAgain() {
    document.documentElement.style.overflow = this.pageOverflow;
    document.documentElement.style.paddingRight = this.pagePaddingRight;
    document.body.style.overscrollBehavior = this.bodyOverscroll;
  }
}
